const useApplicationSettings = () => {
    return {
        mainContainerStyles: {
            width: '100%',
            padding: 2,
            borderRadius: 2,
            boxShadow: '0px 12px 24px -4px #919EAB1F,0px 0px 2px 0px #919EAB33',
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        headerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }
    };
};
export default useApplicationSettings;
